import React, { Fragment, useEffect } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import ObjectActiveIncidentsPanel from './active-incident-panel/index.tsx';
import type { Props } from './types.tsx';

export const ObjectActiveIncidentsPanelList = ({ services }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireTrackAnalytics(createAnalyticsEvent({}), 'activeIncidentPanelList rendered', {
			numOfServices: services.length,
		});
	}, [createAnalyticsEvent, services.length]);

	return (
		<>
			{services.map(({ name, id }) => (
				<Fragment key={id}>
					<ObjectActiveIncidentsPanel serviceId={id} serviceName={name} />
					<PanelDividerLine />
				</Fragment>
			))}
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PanelDividerLine = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:last-child': {
		display: 'none',
	},
	height: '2px',
	width: '90%',
	margin: 'auto',

	backgroundColor: token('color.border'),
});
